(function() {
  'use strict';

  var root = document.querySelector('.wishlist-container');
  if (!root) return;

  var T = window.__wlT || { soldOut: 'Sold out', chooseSize: 'Choose', addToCart: 'Add to cart', added: 'Added', addAll: 'Add all to cart', allAdded: 'All added!', allAddedToast: 'All products added to cart', chooseSizeFirst: 'Select size first', friendTitle: "A friend's wishlist", friendSubtitle: 'Products shared with you', emptyOwn: 'Your wishlist is empty', emptyShared: 'This wishlist is empty', continueShopping: 'Continue shopping', removed: 'Removed from wishlist', remove: 'Remove', loading: 'Loading...', loadingSizes: 'Loading sizes...', loadError: 'Could not load wishlist', productError: 'Could not load product', shareCopied: 'Copied!', shareLinkCopied: 'Link copied!', shareEmpty: 'No products to share', shareCopyBtn: 'Copy' };

  var container = document.getElementById('wishlist-content');
  var toastEl = document.getElementById('wishlist-toast');
  var trashSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';
  var LS_META = 'eivy_wl_meta';

  /* ── CID (same logic as wishlist-global) ── */
  var CID = null;
  (function() {
    if (window.__st && window.__st.cid) { CID = String(window.__st.cid); return; }
    var m = document.querySelector('meta[name="shopify-customer-id"]');
    if (m && m.getAttribute('content')) CID = m.getAttribute('content');
  })();

  function getWlKey() { return CID ? 'eivy_wl_' + CID : 'eivy_wl_guest'; }
  function lsGetList() { try { return JSON.parse(localStorage.getItem(getWlKey()) || '[]'); } catch(e) { return []; } }
  function lsSaveList(arr) { try { localStorage.setItem(getWlKey(), JSON.stringify(arr)); } catch(e) {} }
  function getMetaStore() { try { return JSON.parse(localStorage.getItem(LS_META) || '{}'); } catch(e) { return {}; } }

  /* ── Shared view detection ── */
  var urlParams = new URLSearchParams(window.location.search);
  var shareParam = urlParams.get('share');
  var isSharedView = !!shareParam;

  if (isSharedView) {
    document.getElementById('wishlist-title').textContent = T.friendTitle;
    document.getElementById('wishlist-subtitle').textContent = T.friendSubtitle;
    document.getElementById('share-btn').style.display = 'none';
  }

  /* ── Toast ── */
  function showToast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    setTimeout(function() { toastEl.classList.remove('show'); }, 2500);
  }

  /* ── Cart update event for Horizon theme ── */
  function triggerHorizonCartUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount: cart.item_count, source: 'wishlist' } }
        }));
      }).catch(function() {});
  }

  /* ── Title helpers ── */
  function extractColor(title) {
    if (!title) return '';
    var parts = title.split(' - ');
    if (parts.length < 2) return '';
    var last = parts[parts.length - 1].trim();
    var pipeIdx = last.indexOf('|');
    if (pipeIdx !== -1) last = last.substring(0, pipeIdx).trim();
    return last;
  }

  function extractBaseTitle(title) {
    if (!title) return title;
    var parts = title.split(' - ');
    if (parts.length < 2) return title;
    return parts.slice(0, -1).join(' - ').trim();
  }

  /* ── Add to cart ── */
  function addToCart(handle, btn, variantId) {
    if (!handle) { showToast(T.missingHandle); return; }
    var origText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    function doAdd(vid) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      }).then(function(r) { if (!r.ok) throw new Error('Kunde inte lägga i varukorgen'); return r.json(); });
    }
    function onSuccess() {
      btn.textContent = T.added; btn.disabled = false;
      showToast(T.added);
      triggerHorizonCartUpdate();
      setTimeout(function() { btn.textContent = origText; }, 1500);
    }
    function onError(err) { btn.textContent = origText; btn.disabled = false; showToast(err.message || T.genericError); }

    if (variantId) {
      doAdd(variantId).then(onSuccess).catch(onError);
    } else {
      fetch('/products/' + handle + '.js')
        .then(function(r) { if (!r.ok) throw new Error('Produkt hittades inte'); return r.json(); })
        .then(function(product) {
          var vid = product.variants && product.variants[0] ? product.variants[0].id : null;
          if (!vid) throw new Error('Ingen variant tillgänglig');
          return doAdd(vid);
        }).then(onSuccess).catch(onError);
    }
  }

  /* ── Open quick-add modal ── */
  var qaCache = {};
  /* Section id of the product template's main section. Lets us fetch only the buy area via the
     Section Rendering API (~175KB) instead of the whole product page (~940KB). Seeded with the
     live theme's id; if it's ever wrong (another theme/template) wlFetchGrid falls back to the
     full page and re-learns the correct id. Mirrors assets/quick-add.js. */
  var wlSectionId = 'template--28834665070979__main';
  var wlToken = 0;

  function wlSkeleton() {
    var mc = document.getElementById('quick-add-modal-content');
    if (!mc) return;
    var chips = '';
    for (var i = 0; i < 6; i++) chips += '<div class="quick-add-modal__skeleton-chip"></div>';
    mc.innerHTML =
      '<div class="quick-add-modal__skeleton" aria-hidden="true">' +
        '<div class="quick-add-modal__skeleton-bar" style="height:26px;width:66%"></div>' +
        '<div class="quick-add-modal__skeleton-bar" style="height:20px;width:32%"></div>' +
        '<div class="quick-add-modal__skeleton-row">' + chips + '</div>' +
        '<div class="quick-add-modal__skeleton-bar" style="height:50px;width:100%;margin-top:4px;border-radius:8px"></div>' +
      '</div>';
  }

  function wlGridHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.querySelector('[data-product-grid-content]');
    return { hasForm: !!(grid && grid.querySelector('product-form-component')), html: grid ? grid.innerHTML : null };
  }

  /* Split the injected modal title into "Base name" (line 1) + "Color" (line 2), mirroring the
     product-card layout. Styling lives in custom-wishlist.css (.wl-modal-title-*). */
  function wlDecorateModal(mc) {
    if (!mc) return;
    var titleEl = mc.querySelector('.view-product-title');
    if (!titleEl || titleEl.getAttribute('data-wl-split') === '1') return;
    var full = (titleEl.textContent || '').trim();
    var color = extractColor(full);
    var base = extractBaseTitle(full);
    if (!color || !base) return;
    var link = titleEl.querySelector('a');
    var href = link ? link.getAttribute('href') : null;
    var inner = '<span class="wl-modal-title-base">' + base + '</span>' +
                '<span class="wl-modal-title-color">' + color + '</span>';
    titleEl.innerHTML = href ? '<a href="' + href + '">' + inner + '</a>' : inner;
    titleEl.classList.add('wl-modal-title--split');
    titleEl.setAttribute('data-wl-split', '1');
  }

  /* Resolves to the buy-area HTML for a handle. Tries the lightweight product section first,
     falling back to the full product page (and re-learning the section id) if needed. Cached. */
  function wlFetchGrid(handle) {
    if (qaCache[handle]) return Promise.resolve(qaCache[handle]);
    var full = '/products/' + handle;
    return fetch(full + '?section_id=' + wlSectionId)
      .then(function(r) { return r.ok ? r.text() : null; })
      .then(function(txt) {
        var parsed = txt ? wlGridHtml(txt) : null;
        if (parsed && parsed.hasForm) { qaCache[handle] = parsed.html; return parsed.html; }
        return fetch(full)
          .then(function(r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function(pageHtml) {
            var m = pageHtml.match(/shopify-section-(template--\d+__main)/);
            if (m) wlSectionId = m[1];
            var p2 = wlGridHtml(pageHtml);
            if (p2.html) qaCache[handle] = p2.html;
            return p2.html;
          });
      });
  }

  function wlPrefetch(handle) {
    if (!handle || qaCache[handle]) return;
    wlFetchGrid(handle).catch(function() {});
  }

  function openQuickAddModal(handle, btn) {
    var modalContent = document.getElementById('quick-add-modal-content');
    var dialog = document.getElementById('quick-add-dialog');
    if (!modalContent || !dialog) return;
    var openDialog = function() { if (typeof dialog.showDialog === 'function') dialog.showDialog(); };
    var token = ++wlToken;

    /* Already have it (from a prefetch or previous open): fill first, then open — no flash. */
    if (qaCache[handle]) {
      modalContent.innerHTML = qaCache[handle];
      wlDecorateModal(modalContent);
      openDialog();
      return;
    }

    /* Otherwise open immediately with a skeleton so the tap feels instant, then fetch and fill. */
    wlSkeleton();
    openDialog();

    wlFetchGrid(handle)
      .then(function(gridHtml) {
        if (token !== wlToken) return; /* another item took over the shared dialog */
        if (!gridHtml) { showToast(T.productError); if (dialog.closeDialog) dialog.closeDialog(); return; }
        var mc = document.getElementById('quick-add-modal-content');
        if (mc) { mc.innerHTML = gridHtml; wlDecorateModal(mc); }
      })
      .catch(function() {
        if (token !== wlToken) return;
        showToast(T.productError);
        if (dialog.closeDialog) dialog.closeDialog();
      });
  }

  /* ── Render wishlist items ── */
  function renderItems(items) {
    if (!items || !items.length) {
      container.innerHTML = '<div class="wishlist-empty"><p>' + (isSharedView ? T.emptyShared : T.emptyOwn) + '</p><a href="/collections/all">' + T.continueShopping + '</a></div>';
      document.getElementById('add-all-btn').style.display = 'none';
      if (!isSharedView) document.getElementById('share-btn').style.display = 'none';
      return;
    }

    var html = '<div class="wishlist-grid">';
    items.forEach(function(item) {
      var img = item.product_image_url || 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="400"><rect fill="%23f5f5f5" width="300" height="400"/></svg>';
      var link = item.product_handle ? '/products/' + item.product_handle : '#';
      var color = extractColor(item.product_title);
      var baseTitle = extractBaseTitle(item.product_title) || item.product_title || item.product_handle || 'Produkt';

      html += '<div class="wishlist-card" data-product-id="' + item.shopify_product_id + '" data-handle="' + (item.product_handle || '') + '">';
      html += '<div class="wishlist-card-media">';
      html += '<a href="' + link + '" class="wishlist-card-img"><img src="' + img + '" alt="' + (item.product_title || '') + '"></a>';
      html += '<button class="wishlist-atc js-wl-atc" data-handle="' + (item.product_handle || '') + '" disabled>' + T.chooseSize + '</button>';
      html += '</div>';
      html += '<div class="wishlist-card-info">';
      html += '<div class="wishlist-card-title-row">';
      html += '<div class="wishlist-card-title"><a href="' + link + '">' + baseTitle + '</a></div>';
      if (!isSharedView) {
        html += '<button class="wishlist-card-trash js-wl-remove" title="' + T.remove + '" data-pid="' + item.shopify_product_id + '">' + trashSvg + '</button>';
      }
      html += '</div>';
      if (color) html += '<div class="wishlist-card-color">' + color + '</div>';
      if (item.product_price) html += '<div class="wishlist-card-price">' + item.product_price + '</div>';
      html += '</div></div>';
    });
    html += '</div>';
    container.innerHTML = html;

    /* Fetch product data for sizes + fill missing title/image/price */
    items.forEach(function(item) {
      if (!item.product_handle) return;
      fetch('/products/' + item.product_handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var card = container.querySelector('[data-product-id="' + item.shopify_product_id + '"]');
          if (!card) return;

          /* Fill missing title */
          if (!item.product_title && p.title) {
            var titleEl = card.querySelector('.wishlist-card-title a');
            if (titleEl) titleEl.textContent = extractBaseTitle(p.title) || p.title;
          }

          /* Fill missing image */
          if (!item.product_image_url && p.featured_image) {
            var imgEl = card.querySelector('.wishlist-card-img img');
            if (imgEl) imgEl.src = p.featured_image;
          }

          /* Fill missing price */
          if (!item.product_price && p.price) {
            var priceStr = (p.price / 100).toFixed(0) + ' SEK';
            if (!card.querySelector('.wishlist-card-price')) {
              var priceDiv = document.createElement('div');
              priceDiv.className = 'wishlist-card-price';
              priceDiv.textContent = priceStr;
              var sizePicker = card.querySelector('.wishlist-size-picker');
              if (sizePicker) sizePicker.parentNode.insertBefore(priceDiv, sizePicker);
            }
          }

          /* ATC / size selection */
          var atcBtn = card.querySelector('.wishlist-atc');
          if (!atcBtn || !p.variants) return;

          var hasOnlyDefaultVariant = p.variants.length === 1 && p.variants[0].title === 'Default Title';
          var anyAvailable = p.variants.some(function(v) { return v.available; });

          if (!anyAvailable) {
            atcBtn.disabled = true;
            atcBtn.textContent = T.soldOut;
            atcBtn.classList.add('wishlist-atc--soldout');
            return;
          }

          if (hasOnlyDefaultVariant) {
            atcBtn.disabled = false;
            atcBtn.textContent = T.addToCart;
            atcBtn.setAttribute('data-variant-id', p.variants[0].id);
          } else {
            atcBtn.disabled = false;
            atcBtn.textContent = T.chooseSize;
            atcBtn.setAttribute('data-quick-add', 'true');
          }
        })
        .catch(function() {
          var card = container.querySelector('[data-product-id="' + item.shopify_product_id + '"]');
          if (card) {
            var btn = card.querySelector('.wishlist-atc');
            if (btn) { btn.disabled = false; btn.textContent = T.chooseSize; btn.setAttribute('data-quick-add', 'true'); }
          }
        });
    });

    /* Event listeners */
    container.querySelectorAll('.js-wl-atc').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.getAttribute('data-quick-add') === 'true') {
          var h = btn.getAttribute('data-handle');
          if (h) openQuickAddModal(h, btn);
        } else {
          var h = btn.getAttribute('data-handle');
          var vid = btn.getAttribute('data-variant-id');
          if (h) addToCart(h, btn, vid ? Number(vid) : null);
        }
      });
      /* Warm the quick-add content on hover/press so the modal is usually ready on click.
         (data-quick-add is set asynchronously, so check it at pointer time.) */
      var prefetch = function() {
        if (btn.getAttribute('data-quick-add') === 'true') wlPrefetch(btn.getAttribute('data-handle'));
      };
      btn.addEventListener('pointerenter', prefetch);
      btn.addEventListener('pointerdown', prefetch);
    });
    container.querySelectorAll('.js-wl-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pid = btn.getAttribute('data-pid');
        if (pid) removeItem(pid, btn);
      });
    });
  }

  /* ── Klaviyo remove tracking ── */
  function klaviyoTrackRemove(pid, handle, title, image, price) {
    try {
      var priceFloat = parseFloat((price || '').replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
      var productUrl = window.location.origin + '/products/' + handle;
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
      var payload = { '$value': priceFloat, 'currency': currency, 'RemovedItemProductName': title || '', 'RemovedItemProductID': pid, 'RemovedItemSKU': handle, 'RemovedItemImageURL': image || '', 'RemovedItemURL': productUrl, 'RemovedItemPrice': priceFloat, 'Items': [{ ProductID: pid, SKU: handle, ProductName: title || '', Quantity: 1, ItemPrice: priceFloat, RowTotal: priceFloat, ImageURL: image || '', ProductURL: productUrl, Currency: currency }] };
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Removed from Wishlist', payload);
      else if (window._learnq) window._learnq.push(['track', 'Removed from Wishlist', payload]);
    } catch(e) {}
  }

  /* ── Remove item from localStorage ── */
  function removeItem(productId, btn) {
    var m = getMetaStore()[productId] || {};
    var arr = lsGetList().filter(function(id) { return id !== productId; });
    lsSaveList(arr);
    var card = btn.closest('.wishlist-card');
    if (card) card.remove();
    showToast(T.removed);
    klaviyoTrackRemove(productId, m.handle || '', m.title || '', m.image || '', m.price || '');
    try { window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { removed: productId } })); } catch(e) {}
    var remaining = document.querySelectorAll('.wishlist-card');
    if (!remaining.length) renderItems([]);
  }

  /* ── Add all to cart ── */
  document.getElementById('add-all-btn').addEventListener('click', function() {
    var cards = document.querySelectorAll('.wishlist-card');
    if (!cards.length) return;
    var self = this;
    self.textContent = '...';
    self.disabled = true;

    var promises = [];
    cards.forEach(function(card) {
      var atcBtn = card.querySelector('.wishlist-atc');
      var vid = atcBtn ? atcBtn.getAttribute('data-variant-id') : null;
      if (vid) {
        promises.push(Promise.resolve({ id: Number(vid), quantity: 1 }));
      } else {
        var h = card.getAttribute('data-handle');
        if (!h) return;
        promises.push(
          fetch('/products/' + h + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              if (!p.variants) return null;
              var av = p.variants.find(function(v) { return v.available; });
              if (av) return { id: av.id, quantity: 1 };
              return null;
            }).catch(function() { return null; })
        );
      }
    });

    Promise.all(promises).then(function(results) {
      var valid = results.filter(Boolean);
      if (!valid.length) {
        self.textContent = T.addAll;
        self.disabled = false;
        showToast(T.chooseSizeFirst);
        return;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: valid })
      }).then(function(r) {
        if (!r.ok) throw new Error();
        return r.json();
      }).then(function() {
        self.textContent = T.allAdded;
        showToast(T.allAddedToast);
        triggerHorizonCartUpdate();
        setTimeout(function() { self.textContent = T.addAll; self.disabled = false; }, 2000);
      });
    }).catch(function() {
      self.textContent = T.addAll;
      self.disabled = false;
      showToast(T.genericError);
    });
  });

  /* ── Share (URL-based, no server required) ── */
  var overlay = document.getElementById('share-overlay');
  var shareBtn = document.getElementById('share-btn');
  var closeBtn = document.getElementById('share-close');
  var copyBtn = document.getElementById('share-copy-btn');
  var linkInput = document.getElementById('share-link-input');

  function closeShareModal() { overlay.classList.remove('open'); }

  shareBtn.addEventListener('click', function() {
    overlay.classList.add('open');
    var meta = getMetaStore();
    var ids = lsGetList();
    var handles = ids.map(function(pid) { return meta[pid] && meta[pid].handle; }).filter(Boolean);
    if (handles.length) {
      var shareRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      linkInput.value = window.location.origin + shareRoot + 'pages/wishlist?share=' + handles.join(',');
    } else {
      linkInput.value = T.shareEmpty;
    }
  });

  closeBtn.addEventListener('click', closeShareModal);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeShareModal(); });

  copyBtn.addEventListener('click', function() {
    linkInput.select();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(linkInput.value).then(function() {
        copyBtn.textContent = T.shareCopied;
        showToast(T.shareLinkCopied);
        setTimeout(function() { copyBtn.textContent = T.shareCopyBtn; }, 2000);
      });
    } else {
      document.execCommand('copy');
      copyBtn.textContent = T.shareCopied;
      showToast(T.shareLinkCopied);
      setTimeout(function() { copyBtn.textContent = T.shareCopyBtn; }, 2000);
    }
  });

  /* ── Load wishlist ── */
  if (isSharedView) {
    /* Shared view: fetch products by handle from URL param */
    var handles = shareParam.split(',').map(function(h) { return h.replace(/[^a-z0-9-]/g, ''); }).filter(Boolean).slice(0, 50);
    var proms = handles.map(function(h) {
      return fetch('/products/' + h + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          return {
            shopify_product_id: String(p.id),
            product_handle: p.handle,
            product_title: p.title,
            product_image_url: p.featured_image || '',
            product_price: p.price ? ((p.price / 100).toFixed(0) + ' SEK') : ''
          };
        }).catch(function() { return null; });
    });
    Promise.all(proms)
      .then(function(items) { renderItems(items.filter(Boolean)); })
      .catch(function() { container.innerHTML = '<div class="wishlist-empty"><p>' + T.loadError + '</p></div>'; });
  } else {
    /* Own wishlist: read from localStorage */
    var pids = lsGetList();
    var meta = getMetaStore();
    var items = pids.map(function(pid) {
      var m = meta[pid] || {};
      return {
        shopify_product_id: pid,
        product_handle: m.handle || '',
        product_title: m.title || '',
        product_image_url: m.image || '',
        product_price: m.price || ''
      };
    }).filter(function(item) { return item.product_handle; });
    renderItems(items);
  }
})();
